import React from 'react';
import AdminStructure from './AdminStructure';  

const AdminHome = () => {
    return <AdminStructure />;
};

export default AdminHome;
